export default [
  {
    name: 'wa-template',
    path: '/wa/template',
    component: () => import(/* webpackChunkName: "wa-templates" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Templates WhatsApp',
      icon: 'bx bx-message-square-detail',
      label: 'Templates WhatsApp',
      roles: ['Admin']
    }
  },
  {
    name: 'wa-template-create',
    path: '/wa/template/create',
    component: () => import(/* webpackChunkName: "wa-templates" */ './Create.vue'),
    meta: {
      showNavbar: true,
      title: 'Criar Template',
      roles: ['Admin']
    }
  },
  {
    name: 'wa-template-edit',
    path: '/wa/template/:id/edit',
    component: () => import(/* webpackChunkName: "wa-templates" */ './Create.vue'),
    meta: {
      showNavbar: true,
      title: 'Editar Template',
      roles: ['Admin']
    }
  }
]
